export default "__VITE_ASSET__4imAe6wW__"